export default __webpack_public_path__ + "static/media/iStock-695360068.4e6c7ac9.jpg";